import { useEffect, useState } from "react";
import { updateStoresForm } from "../../lib/actions";
import { useNavigate, useParams } from "react-router-dom";
import { FiUploadCloud } from "react-icons/fi";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { ThreeDot } from "react-loading-indicators";
import { useTranslation } from "react-i18next";
import DropDown from "../../components/GDropDownList/DropDown";

export default function EditStoresUi({ TopResultOfPackags, positionOfPackags, storeByIdData }) {
  const nav = useNavigate();
  const { storeId } = useParams();
  const [selectedValues, setSelectedValues] = useState({position : null, topResult : null});
  const [check, setCheck] = useState(null);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();
  const t = i18n.t.bind(i18n);
  const currentLang = i18n.language;

  useEffect(() => {
    setImage(storeByIdData?.photo || null);
    setCheck(storeByIdData.active);
    setSelectedValues((prev)=>({
      ...prev, 
      position : storeByIdData.position,
      topResult : storeByIdData.topResult == true ? "1" : "0",
    }));
  }, [storeByIdData]);

  const onChange = (e, paramkey) => {
    setSelectedValues(prev => ({
        ...prev,
        [paramkey]: e
    }));
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    const formData = new FormData(e.target);
    const result = await updateStoresForm(storeId, formData, navigate);
    setLoading(false);
  };

  const navigate = (route) => {
    nav(route);
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setImage(URL.createObjectURL(file));
    }
  };

  const handleChangeCheck = () => {
    setCheck(!check);
  };

  const handleDeleteImage = () => {
    setImage(null);
  };

  if (Object.entries(storeByIdData || {}).length < 1) {
    return (
      <div className="flex justify-center items-center h-[25rem]">
        <ThreeDot variant="bounce" color="#2F7A74" size="large" text="" textColor="" />
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 sm:grid-cols-1 gap-3 pb-3">
        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "name in arabic" : "الاسم باللغة العربية "}
          </label>
          <input
            type="text"
            defaultValue={storeByIdData?.name?.ar || ""}
            name="name_ar"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={
              currentLang === "en"
                ? "enter name in arabic"
                : "أدخل الاسم باللغة العربية "
            }
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "name in english" : "الاسم باللغة الانجيليزية "}
          </label>
          <input
            type="text"
            defaultValue={storeByIdData?.name?.en || ""}
            name="name_en"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={
              currentLang === "en"
                ? "enter name in english"
                : " أدخل الاسم باللغة الانجليزية "
            }
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "description in arabic" : "الوصف باللغة العربية "}
          </label>
          <input
            type="text"
            defaultValue={storeByIdData?.description?.ar || ""}
            name="description_ar"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={
              currentLang === "en"
                ? "enter description in arabic"
                : "أدخل الوصف باللغة العربية "
            }
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "description in english" : "الوصف باللغة الانجليزية "}
          </label>
          <input
            type="text"
            defaultValue={storeByIdData?.description?.en || ""}
            name="description_en"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={
              currentLang === "en"
                ? "enter description in english"
                : "أدخل الوصف باللغة الانجليزية "
            }
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "address in arabic" : "العنوان باللغة العربية "}
          </label>
          <input
            type="text"
            defaultValue={storeByIdData?.address?.ar || ""}
            name="address_ar"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={
              currentLang === "en"
                ? "enter address in arabic"
                : "أدخل العنوان باللغة العربية "
            }
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "address in english" : "العنوان باللغة الانجليزية "}
          </label>
          <input
            type="text"
            defaultValue={storeByIdData?.address?.en || ""}
            name="address_en"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={
              currentLang === "en"
                ? "enter address in english"
                : "أدخل العنوان باللغة الانجليزية "
            }
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "phone" : "الهاتف"}
          </label>
          <input
            type="text"
            defaultValue={storeByIdData?.phone || ""}
            name="phone"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            required
            placeholder={currentLang === "en" ? "enter phone" : "أدخل الهاتف"}
          />
        </div>

        {/* Passwords optional on edit */}
        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "password (leave empty to keep)" : "كلمة المرور (اتركها فارغة إذا لم تتغير)"}
          </label>
          <input
            type="password"
            name="password"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={currentLang === "en" ? "enter password" : "أدخل كلمة المرور"}
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">
            {currentLang === "en" ? "confirm password" : "تأكيد كلمة المرور"}
          </label>
          <input
            type="password"
            name="password_confirmation"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder={currentLang === "en" ? "confirm password" : "تأكيد كلمة المرور"}
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">Latitude</label>
          <input
            type="number"
            step="any"
            defaultValue={storeByIdData?.latitude || ""}
            name="latitude"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder="e.g. 34.8000"
          />
        </div>

        <div className="mb-4">
          <label className="block text-white mb-2">Longitude</label>
          <input
            type="number"
            step="any"
            defaultValue={storeByIdData?.longitude || ""}
            name="longitude"
            className="w-full px-4 py-2 bg-thirdly border border-gray-500/100 text-white rounded-lg"
            placeholder="e.g. 36.0000"
          />
        </div>

        <div className="mb-4">
            <label className="block text-white mb-2">{currentLang === "en" ? "place of appearance" : "مكان الظهور"}</label>
            <DropDown options={positionOfPackags} value={selectedValues.position} defaultText={currentLang === "en" ? "enter place of appearance" : "ادخل مكان الظهور"} paramkey="position" onchange={(e)=>onChange(e, "position")} />
        </div>
        <div className="mb-4">
            <label className="block text-white mb-2">{currentLang === "en" ? "order of appearance" : "ترتيب الظهور"}</label>
            <DropDown options={TopResultOfPackags} value={selectedValues.topResult} defaultText={currentLang === "en" ? "enter order of appearance" : "ادخل ترتيب الظهور"} paramkey="topResult" onchange={(e)=>onChange(e, "topResult")} />
        </div>

        {/* <div className="mb-4 flex items-center gap-3">
          <input type="checkbox" name="active" defaultChecked={storeByIdData?.active ?? true} />
          <label className="text-white">{currentLang === "en" ? "active" : "نشط"}</label>
        </div> */}
        <div className=" flex items-center gap-4 ms-3 mt-4">
            <div
                onClick={handleChangeCheck}
                className={`relative w-14 h-6 rounded-full cursor-pointer transition
                ${check ? (currentLang === 'ar' ? 'bg-secondary' : 'bg-secondary') : (currentLang === 'ar' ? 'bg-gray-400' : 'bg-gray-400')}`}
            >
                <span
                className={`w-5 h-4 mt-1 bg-white rounded-full shadow-md block
                    transform transition
                    ${check ? (currentLang === 'ar' ? '-translate-x-1' : 'translate-x-7') : (currentLang === 'ar' ? '-translate-x-7' : 'translate-x-1')}`}
                />
            </div>
            <label className="text-white">
              {check
                  ? currentLang === "en"
                  ? "active"
                  : "نشط"
                  : currentLang === "en"
                  ? "un active"
                  : "غير نشط"
              }
            </label>
        </div>
      </div>

      <div className="mb-4">
        <label className="block text-white mb-6">{currentLang === "en" ? "photo" : "الصورة"}</label>
        <div className="flex justify-center items-center">
          <div className="bg-thirdly sm:w-[50%] w-[100%] p-6 rounded-2xl border-2 border-dashed border-gray-200">
            <div className="relative group">
              <div className={`flex flex-col items-center justify-center  h-48 ${!image ? "bg-furthly" : "bg-transparent"} rounded-xl transition-all`}>
                {!image ? (
                  <>
                    <FiUploadCloud className="w-12 h-12 text-white mb-3 group-hover:text-secondary transition-colors" />
                    <span className="text-sm text-white group-hover:text-secondary transition-colors">
                      {currentLang === "en" ? "click to upload a photo" : " انقر لرفع الصورة"}
                    </span>
                  </>
                ) : (
                  <div className="relative w-full h-full">
                    <img src={image} alt="الصورة الملتقطة" className="w-full h-full object-contain rounded-xl" />
                    <button type="button" className="absolute top-2 left-2 z-50 bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors shadow-lg" onClick={handleDeleteImage}>
                      <MdOutlineDeleteOutline className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>
              <input type="file" name="photo" accept="image/*" className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" onChange={handleImageChange} />
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center w-full mt-5">
        <button
          type="submit"
          disabled={loading}
          className={`w-full sm:w-2/5 md:w-[14%] bg-secondary text-white py-2 rounded-lg transition flex items-center justify-center ${loading ? "cursor-not-allowed" : "hover:bg-primary"}`}
        >
          {loading ? (
            <>
              <svg
                className="animate-spin h-5 w-5 "
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
            </>
          ) : (
            t("button.save")
          )}
        </button>
      </div>
    </form>
  );
}
